import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!slick-carousel';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import '../scss/entry.scss';

jQuery(document).ready(function($) {
	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// acf accordions
	$('.acf-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.icon').children('.plus-minus').toggleClass('plusser minus');
	});

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).next('.accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
		$(this).toggleClass('active');
	});

	// simple accordions
	$('.simple-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
	});

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1
		});
	});

	// primary navigation toggle
	// A class rather than slideToggle: the nav wrapper is a flex item, and
	// jQuery's slide left it at height:0 with overflow:hidden, clipping the
	// menu to nothing. CSS owns the open/closed state now.
	$('.nav-toggle').on('click', function() {
		$('#masthead').toggleClass('nav-open');
		$('body').toggleClass('nav-open');
	});

	// close the mobile nav on resize back to desktop
	$(window).on('resize', function() {
		if (window.innerWidth >= 992) {
			$('#masthead, body').removeClass('nav-open');
			$('.nav-toggle').removeClass('is-active');
		}
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// generic ffw carousel -- used by the services / projects / industries blocks.
	// Config comes off data attributes so each block instance can differ.
	$('.ffw-carousel').each(function() {
		var $carousel   = $(this);
		var slides      = parseInt($carousel.data('slides'), 10) || 3;
		var slidesMd    = parseInt($carousel.data('slides-md'), 10) || 2;
		var slidesSm    = parseInt($carousel.data('slides-sm'), 10) || 1;
		var autoplay    = $carousel.data('autoplay') === true || $carousel.data('autoplay') === 'true';
		var speed       = parseInt($carousel.data('autoplay-speed'), 10) || 5000;
		var count       = $carousel.children().length;
		var center      = $carousel.data('center') === true || $carousel.data('center') === 'true';

		// Centre-mode carousels take their centerPadding from the stylesheet
		// (--pc-center-pad) so the CSS and slick cannot disagree about how big
		// the peek is. It changes at breakpoints, so it is re-read on resize.
		function centerPad() {
			return center
				? window.getComputedStyle($carousel[0]).getPropertyValue('--pc-center-pad').trim()
				: '0px';
		}

		var opts = {
			slidesToShow:   slides,
			slidesToScroll: 1,
			arrows:         false,
			dots:           false,
			infinite:       count > slides,
			autoplay:       autoplay && count > slides,
			autoplaySpeed:  speed,
			pauseOnHover:   true,
			pauseOnFocus:   true,
			respondTo:      'window',	// must match the CSS media queries that drive --sc-per-view
			responsive: [
				{ breakpoint: 1101, settings: { slidesToShow: slidesMd, infinite: count > slidesMd, autoplay: autoplay && count > slidesMd } },
				{ breakpoint: 768,  settings: { slidesToShow: slidesSm, infinite: count > slidesSm, autoplay: autoplay && count > slidesSm } }
			]
		};

		if (center) {
			opts.centerMode    = true;
			opts.centerPadding = centerPad();
			// per-view is always 1 in centre mode; drop the responsive overrides
			opts.responsive    = [];
		}

		$carousel.slick(opts);

		var lastPad = opts.centerPadding;
		function syncCenterPad() {
			if (!center) { return; }
			var pad = centerPad();
			if (pad && pad !== lastPad) {
				lastPad = pad;
				$carousel.slick('slickSetOption', 'centerPadding', pad, true);
			}
		}

		// Whether there is anything to scroll depends on the active breakpoint,
		// so the nav is toggled per breakpoint rather than on raw slide count:
		// 3 slides is static at 3-up but scrollable at 1-up.
		//
		// The per-view count is derived from the window rather than read back
		// via slick's API: slick only attaches its instance to the element
		// AFTER the constructor returns, so any slick() call from an `init`
		// handler throws and aborts that assignment, leaving the carousel
		// half-initialised and every later slick() call broken. Bind after
		// init and keep these breakpoints in step with the responsive config
		// above and the CSS media queries driving --sc-per-view.
		function activePerView() {
			var w = window.innerWidth;
			if (w < 768)  { return slidesSm; }
			if (w < 1101) { return slidesMd; }
			return slides;
		}
		function syncNav() {
			$carousel.parent().toggleClass('carousel-nav-inactive', count <= activePerView());
		}

		$carousel.on('breakpoint setPosition', syncNav);
		$(window).on('resize orientationchange', function() {
			syncNav();
			syncCenterPad();
		});
		syncNav();
	});

	// acf slider
	$('.slider-prev').on('click', function(){
		$(this).parent().prev().slick('slickPrev');
	});
	$('.slider-next').on('click', function(){
		$(this).parent().prev().slick('slickNext');
	});

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				console.log('hit')
				prev = now;
				return func(...args);
			}
		}
	}
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));
});